<template>
  <div class="document-container">
    <es-loader v-if="loading" style="margin: 6.5rem"/>
    <es-exception v-else-if="!loading && loadingError"
      exceptionMessage="There was an issue. Please try again or contact your administrator."
    />
    <div class="document" v-else>
      <div class="header">
        <es-header>
          <template #header>
            <div class="header-title">General</div>
            <div class="header-subtitle">
              View General Profile Information.
            </div>
          </template>
        </es-header>
      </div>
      <div class="content">
        <es-form>
          <template #es-form-header>
            <div class="header-container">
              <div class="header-elements">
                <font-awesome-icon :icon="['fas', 'map-marker-alt']" size="lg" />
              </div>
              <div class="header-elements">
                <h6 class="title">
                  Location Information
                </h6>
              </div>
            </div>
          </template>
          <template #es-form>
            <div class="fields-container">

              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">{{ getFieldLabel(`PER:${defaultPersonType}:DIRECTMATCH:DISTRICT_CODE`) }} Name</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input
                        class="input is-static"
                        type="text"
                        v-model="location.name"
                        readonly>
                    </div>
                  </div>
                </div>
              </div>

              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">{{ getFieldLabel(`PER:${defaultPersonType}:DIRECTMATCH:DISTRICT_CODE`) }} Code</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control is-static">
                      <input
                        class="input is-static"
                        type="text"
                        v-model="location.stateLocationId"
                        readonly>
                    </div>
                  </div>
                </div>
              </div>

              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">Address 1</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input
                        class="input is-static"
                        type="text"
                        v-model="location.street1"
                        readonly>
                    </div>
                  </div>
                </div>
              </div>

              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">Address 2</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input
                        class="input is-static"
                        type="text"
                        v-model="location.street2"
                        readonly>
                    </div>
                  </div>
                </div>
              </div>

              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">City</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input
                        class="input is-static"
                        type="text"
                        v-model="location.city"
                        readonly>
                    </div>
                  </div>
                </div>
              </div>

              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">State</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input
                        class="input is-static"
                        type="text"
                        :value="stateMapper"
                        readonly>
                    </div>
                  </div>
                </div>
              </div>

              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">Zip</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input
                        class="input is-static"
                        type="text"
                        :value="maskZip(location.zip)"
                        readonly>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </template>
        </es-form>

        <es-form>
          <template #es-form-header>
            <div class="header-container">
              <div class="header-elements">
                <font-awesome-icon :icon="['fas', 'address-book']" size="lg"/>
              </div>
              <div class="header-elements">
                <h6 class="title">
                  Contact
                </h6>
              </div>
            </div>
          </template>
          <template #es-form>
            <div class="fields-container">

              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">{{ getFieldLabel(`PER:${defaultPersonType}:DIRECTMATCH:FIRST_NAME`) }}</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input
                        class="input is-static"
                        type="text"
                        v-model="location.adminFirstName"
                        readonly>
                    </div>
                  </div>
                </div>
              </div>

              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">{{ getFieldLabel(`PER:${defaultPersonType}:DIRECTMATCH:LAST_NAME`) }}</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input
                        class="input is-static"
                        type="text"
                        v-model="location.adminLastName"
                        readonly>
                    </div>
                  </div>
                </div>
              </div>

              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">Title</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input
                        class="input is-static"
                        type="text"
                        v-model="location.title"
                        readonly/>
                    </div>
                  </div>
                </div>
              </div>

              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">Email</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input
                        class="input is-static"
                        type="text"
                        v-model="location.adminEmail"
                        readonly>
                    </div>
                  </div>
                </div>
              </div>

              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">Phone</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input class="input is-static"
                      type="text"
                      :value="maskPhone(location.adminPhone)"
                      readonly>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </template>
        </es-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAddressBook,
  faMapMarkerAlt,
} from '@fortawesome/pro-solid-svg-icons';

import EsException from '@/components/EsException.vue';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';

import DateUtils from '@/mixins/DateUtils';
import EmailUtils from '@/mixins/EmailUtils';
import PhoneUtils from '@/mixins/PhoneUtils';
import ZipUtils from '@/mixins/ZipUtils';
import FieldLabels from '@/mixins/FieldLabels';

library.add(
  faAddressBook,
  faMapMarkerAlt,
);

export default {
  mixins: [
    DateUtils,
    EmailUtils,
    PhoneUtils,
    ZipUtils,
    FieldLabels,
  ],
  components: {
    EsException,
    EsHeader,
    EsForm,
    EsLoader,
  },
  props: {
    location: {
      type: Object,
      required: true,
    },
  },
  date() {
    return {
      loading: true,
      loadingError: null,
    };
  },
  async created() {
    await this.loadPersonTypes();
    this.onLoad();
  },
  computed: {
    ...mapGetters('lookups', [
      'defaultPersonType',
    ]),
    stateMapper() {
      if (this.$store.state.lookups.states.length) {
        return this.$store.state.lookups.states.find(s => s.code === this.location.stateCode).description;
      }
    },
  },
  methods: {
    ...mapActions('lookups', [
      'loadStates',
      'loadPersonTypes',
    ]),
    async onLoad() {
      try {
        this.loading = true;
        this.loadingError = false;

        this.loadStates();
      } catch (e) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
  },
  filters: {
    formatDateMMDDYYYY(value) {
      if (value) {
        return moment(value).format('MM/DD/YYYY');
      }
      return 'N/A';
    },
  },
}
</script>

<style lang="sass" scoped>
  .document
    max-width: 1408px
</style>
